<template>
<!--    //仅展示-->
    <div v-for="coupon in coupon" v-if="couponListType == 'list'">
        <div class="clearfix couponList paddingr20">
            <div class="flex-container vfull coupon marginr20 marginv10 float-left">
                <div class="couponLeft paddingv20 paddingh20 flex1">
                    <div class="flex-container bottom left">
                        <span class="lh-1 text-limit1" style="font-size:24px;line-height:25px;" v-if="coupon.name">{{coupon.name}}</span>
                        <span class="fs-10 marginl10" v-if="coupon.name" v-text="couponType(coupon.type)"></span>
                    </div>
                    <div class="fs-10 margint10" v-if="coupon.timeStr">{{coupon.timeStr}}</div>
                </div>
                <a href="/coupon/index.html" style="display: inherit;" :data-scp="'coupon.'+$index"><div class="couponRight pos-r text-white flex-container center paddingh30 fs-11" style="width:12px;white-space: normal;">去查看</div></a>
            </div>
        </div>
    </div>
<!--    这个是给脑抽设计用的-->
    <div v-for="coupon in coupon" v-if="couponListType == 'award'">
        <div class="clearfix couponList">
            <div class="flex-container vfull coupon marginr20 marginv10 float-left" style="height: 60px;">
                <div class="couponLeft padding20 flex1 flex-container-col left pos-r">
                    <div class="flex-container left flex1" :class="coupon.awaUrl?'':'bottom'">
                        <div v-if="coupon.awaUrl" class="lh-1 text-limit1 text-left" style="font-size:11px;line-height:18px;font-weight: bold;-webkit-line-clamp: 2">
                            <span v-if="coupon.name">{{coupon.name}}</span>
                        </div>
                        <div v-if="!coupon.awaUrl" class="lh-1 text-limit1" style="font-weight: bold;">
                            <span style="font-size:12px;" v-if="coupon.subTitle.symbol">{{coupon.subTitle.symbol}}</span>
                            <span style="font-size:24px;line-height:25px;" v-if="coupon.subTitle.main">{{coupon.subTitle.main}}</span>
                            <span style="font-size:12px;" v-if="coupon.subTitle.main">{{coupon.subTitle.desc}}</span>
                        </div>
                        <div class="fs-10 marginl10" v-if="coupon.name" v-text="couponType(coupon.type)"></div>
                    </div>
                    <div class="fs-10" style="height:15px;" v-if="coupon.promotionRule">
                        <div class="pos-a left20 text-center" style="bottom:6px;" v-text="getTimeStr(coupon)"></div>
                    </div>
                </div>
                <a :href="coupon.clickUrl" style="display: inherit;" :data-scp="'coupon.'+$index" v-if="coupon.clickUrl"><div class="couponRight pos-r text-white flex-container center paddingh30 fs-11 lh-12" style="width:15px;white-space: normal;">去使用</div></a>
                <a :href="coupon.awaUrl" style="display: inherit;" :data-scp="'coupon.'+$index" v-if="coupon.awaUrl"><div class="couponRight pos-r text-white flex-container center paddingh30 fs-11 lh-12" style="width:15px;white-space: normal;">去看看</div></a>
                <a href="/coupon/index.html" style="display: inherit;" :data-scp="'coupon.'+$index" v-if="!coupon.clickUrl && !coupon.awaUrl"><div class="couponRight pos-r text-white flex-container center paddingh30 fs-11 lh-12" style="width:15px;white-space: normal;">去查看</div></a>
            </div>
        </div>
    </div>
<!--    //带领取的-->
    <div v-for="coupon in localCoupon" v-if="couponListType == 'get'">
        <div class="clearfix couponList paddingr20">
            <div class="flex-container vfull coupon marginr20 marginv10 float-left">
                <div class="paddingv20 paddingh20 flex1" :class="coupon.receiveStatus ? 'couponLeft' : 'couponLeft3'">
                    <div class="flex-container bottom left">
                        <span class="lh-1 text-limit1" style="font-size:24px;line-height:25px;" v-if="coupon.name" v-text="coupon.name"></span>
                        <span class="fs-10 marginl10" v-if="coupon.name" v-text="couponType(coupon.type)"></span>
                    </div>
                    <div class="fs-10 margint10" v-if="coupon.time">{{coupon.time}}</div>
                </div>
                <div class="pos-r text-white flex-container center paddingh30 fs-11 lh-12" :class="coupon.receiveStatus ? 'couponRight' : 'couponRight3'" style="width:12px;white-space: normal;" @click="getCoupon(coupon)">{{coupon.btnText}}</div>
            </div>
        </div>
    </div>
<!--    //品牌自营-->
    <div v-for="coupon in localCoupon" class="paddingv20 paddingr20" v-if="couponListType == 'counter'">
      <div class="pos-r couponCounter flex-container center left"  @click="getCoupon(coupon)">
        <div class="text-white lh-1 paddingl20">
          <div class="flex-container bottom left">
              <span class="lh-1 text-limit1 fs-20" v-if="coupon.name" v-text="coupon.name"></span>
              <span class="fs-10 marginl10" v-if="coupon.name" v-text="couponType(coupon.type)"></span>
          </div>
          <div class="fs-10 margint10" v-if="coupon.time">{{coupon.time}}</div>
        </div>
        <div class="pos-a couponCounterBtn right0 top0"></div>
      </div>
    </div>
</template>
<style lang="scss">
    .coupon{
        width:157px;
    }
    .couponLeft{
        border:1px solid #FF898C;
        background: #FFF6F5;
        border-top-right-radius:6px;
        border-bottom-right-radius:6px;
        color:#FF8A88;
    }
    .couponRight{
        background: #FF898C;
        border-top-left-radius:6px;
        border-bottom-left-radius:6px;
    }
    .couponLeft3{
        border:1px solid #CCCCCC;
        background: #F9F9F9;
        border-top-right-radius:6px;
        border-bottom-right-radius:6px;
        color:#999999;
    }
    .couponRight3{
        background: #CCCCCC;
        border-top-left-radius:6px;
        border-bottom-left-radius:6px;
    }
    .couponList .coupon:last-of-type{
        margin-right: 0;
    }
    .couponRight:after {
        position: absolute;
        content: '';
        width: 8px;
        height: 54px;
        background: radial-gradient(#fff 0px,#fff 2px,transparent 2px,transparent 2px);
        background-size: 9px 9px;
        background-position: -9px -9px;
        left: -5px;
        top: 3px;
    }
    .couponRight3:after {
        position: absolute;
        content: '';
        width: 8px;
        height: 54px;
        background: radial-gradient(#fff 0px,#fff 2px,transparent 2px,transparent 2px);
        background-size: 9px 9px;
        background-position: -9px -9px;
        left: -5px;
        top: 3px;
    }
    .couponCounter{
      width:120px;
      height:64px;
      background:url('//image1.51tiangou.com/tgou2/img2/counter/bg-coupon_counter.png') no-repeat center;
      background-size:100% 100%;
    }
    .couponCounterBtn{
      width:30px;
      height:16px;
      background:url('//image1.51tiangou.com/tgou2/img2/counter/btn-coupon_counter.png') no-repeat center;
      background-size:100% 100%;
    }
</style>
<script>
    import couponServer from '../../api/couponServer.js';
    import memberServer from '../../api/member.js';
    export default {
        props: {
            coupon: {
                type: Array,
                default: []
            },
            couponListType: {
                type: String,
                default: 'list'
            }
        },
        data: function () {

        },
        computed: {
            localCoupon() {
                let tempArr = [];
                this.coupon.map(function (item, index) {
                    if (!item.canReceived && !item.totleRemainQty) {
                        item.btnText = "已抢光";
                        item.receiveStatus = false;
                    } else if (!item.canReceived && item.totleRemainQty && !item.todayRemainQty) {
                        item.btnText = "明日再来";
                        item.receiveStatus = false;
                    } else if (!item.canReceived && item.totleRemainQty && item.todayRemainQty) {
                        if (item.receivedQty >= item.limitQty){
                            item.btnText = "明日再来";
                            item.receiveStatus = false;
                        }else{
                            item.btnText = "已领取";
                            item.receiveStatus = false;
                        }
                    } else if (item.canReceived) {
                        item.btnText = "立即领取";
                        item.receiveStatus = true;
                    }
                    tempArr.push(item)
                })
                return tempArr;
            }
        },
        methods: {
            couponType: function (type) {
                const TAG_NAME_LIST = {
                    '1': '现金券',
                    '2': '折扣券',
                    '3': '满减券',
                    '4': '买送券',
                    '5': '单品券',//已废弃
                    '6': '单品券',//已废弃
                    '7': '信息券',//已废弃
                    '8': '停车券',
                    '9': '礼品券',//保鲜礼
                    '10': '抵值券',
                    '11': '打折券',
                    '14': '礼品券',
                    '15': '运费券',
                    '16': '克减券',//黄金克减券
                    '17': '运费券'//运费满减
                };
                return TAG_NAME_LIST[type]
            },

            getCoupon(item) {
                item.receiveStatus && couponServer.couponCodeAdd({
                    data: {
                        couponId: item.id,
                        amount: item.payAmount
                    },
                    success(data) {
                        maple.notice('领取成功')
                    },
                    tgError: (data) => {
                        if (data.code == 1001){
                            let errorObj = JSON.parse(data.message);
                            if (errorObj.code == 10001){
                                maple.confirm({
                                    content: errorObj.msg,
                                    cancelText: '取消',
                                    cancelFn: ()=>{},
                                    okText: '创建会员并领取',
                                    okFn: ()=>{
                                        memberServer.createCard({
                                            data:{
                                                phone:maple.cookie('cellPhone'),
                                                storeId:item.storeIds[0]
                                            },
                                            success:function () {
                                                maple.notice('开通成功');
                                            },
                                            tgError:function () {
                                                maple.alert({
                                                    content:'当前店铺无法开通会员卡'
                                                })
                                            }
                                        });
                                    }
                                })
                            } else if(errorObj.code == 10002) {
                                maple.confirm({
                                    content: '<div class="text-center padding50"><img src="//image1.51tiangou.com/tgou2/img2/bg-cards.png" width="90"><div class="text-dark margint20">发现你有可用的会员卡，绑定会员卡即可享受积分和优惠活动，是否现在绑定？</div></div>',
                                    cancelText: '取消',
                                    cancelFn: ()=>{},
                                    okText: '绑定',
                                    okFn: ()=>{
                                        let cid = errorObj.cardInfo.cardId;
                                        let groupId = errorObj.cardInfo.groupId;
                                        memberServer.noValidate({
                                            data:{
                                                cid:cid,
                                                groupId: groupId
                                            },
                                            success:function(data) {
                                                if(data) {
                                                    maple.notice('绑定成功，已获得电子会员特权');
                                                    setTimeout(function () {
                                                        location.reload();
                                                    }, 2000)
                                                }else {
                                                    maple.pageIns.changePage('../cards/bindcardinfo.html', {cardId: cid, groupId: groupId})
                                                }
                                            }
                                        })
                                    }
                                })
                            }else{
                                maple.notice(errorObj.msg)
                            }
                        }else{
                            if (data.code == 666 && this.couponListType === 'get') {
                                let tpl = '领取失败' + '<br/>' + data.message;
                                maple.notice(tpl, 'info')
                                item.receiveStatus = false;
                                if (data.message.indexOf('每日') > -1){
                                    item.btnText = '明日再来'
                                } else if (data.message.indexOf('总数上限') > -1) {
                                    item.btnText = '已抢光'
                                }else if (data.message.indexOf('每人限领数上限') > -1) {
                                    item.btnText = '已领取'
                                }
                            }else{
                                maple.notice(data.message)
                            }
                        }
                    }
                })
            },

            getTimeStr({startTime, endTime, promotionRule = '{}'}){
                startTime = startTime?new Date(startTime):'';
                endTime = endTime?new Date(endTime):'';
                promotionRule = JSON.parse(promotionRule);

                let fixedLength = promotionRule.fixedLength || 0;

                if(startTime && endTime){
                    let startStr =  startTime && `${startTime.getFullYear()}.${_.padStart(startTime.getMonth()+1, 2, 0)}.${_.padStart(startTime.getDate(), 2, 0)}`;
                    let endStr =  endTime && `-${endTime.getFullYear()}.${_.padStart(endTime.getMonth()+1, 2, 0)}.${_.padStart(endTime.getDate(), 2, 0)}`;

                    return startStr + endStr;
                }else if(fixedLength){
                    return `自领取之日起${fixedLength}天`
                }
            },
        }
    }
</script>